'use client';
import { getText } from '@/utils/text/text';
import { RichText } from '@/app/components/rich-text/rich-text';
import type { RichTextElement } from '@/app/components/rich-text/rich-text.types';
import { InfoPanel } from '@/app/components/site-wide-jackpot/subcomponents/info-panel/info-panel';
import { Breadcrumbs } from '@/app/components/breadcrumbs';
// import { useStore } from '@/store/store';

type RulesFullVersionProps = {
    description?: RichTextElement[];
    tc_full_version?: RichTextElement[] | string;
    tc_short_version?: RichTextElement[] | string;
    videoUrl?: string;
    logoUrl?: string;
    title_subtitle?: RichTextElement[];
};

const SWJRules = (props: RulesFullVersionProps) => {
    const { description, tc_full_version, tc_short_version, title_subtitle, videoUrl, logoUrl } = props;
    // const optedInStatus = useStore((state) => state.siteWideJackpot.multiplier);

    // TODO refactor when user tracking will be implemented
    // const { updatedTiers } = useSiteWideJackpotFeed();
    // const tierAmounts = updatedTiers.map((tier:Tier) => tier.currentAmount);
    // const trackEventData = {
    //     [USER_TRACKING_PROPERTY.VIDEO_TITLE]: JACKPOTS.VIDEO_TITLE,
    //     [USER_TRACKING_PROPERTY.OPTED_IN_STATUS]: optedInStatus,
    //     [USER_TRACKING_PROPERTY.MEGA_POT_AMOUNT]: tierAmounts[0],
    //     [USER_TRACKING_PROPERTY.MAJOR_POT_AMOUNT]: tierAmounts[1],
    //     [USER_TRACKING_PROPERTY.MINOR_POT_AMOUNT]: tierAmounts[2],
    //     [USER_TRACKING_PROPERTY.MINI_POT_AMOUNT]: tierAmounts[3],
    // };
    const handleVideoClick = () => {
        // utTrackVideoTrailerInteraction({
        //     ...trackEventData,
        //     ...{ [USER_TRACKING_PROPERTY.EVENT]: EVENT_TYPE.JACKPOT_VIDEO_TRAILER_CLICKED }
        // });
    };
    const handleVideoEnded = () => {
        // utTrackVideoTrailerInteraction({
        //     ...trackEventData,
        //     ...{ [USER_TRACKING_PROPERTY.EVENT]: EVENT_TYPE.JACKPOT_VIDEO_TRAILER_COMPLETED }
        // });
    };

    return (
        <div className="swj-rules">
            <div className="swj-rules__hero">
                <div className="swj-rules__hero-top">
                    <img src={logoUrl} alt="site wide jackpot logo" className="swj-rules__logo" />
                    <div className="swj-rules__intro-text">
                        <div className="swj-rules__content-title">{title_subtitle?.[0]?.text}</div>
                        <div className="swj-rules__content-subtitle">{title_subtitle?.[1]?.text}</div>
                    </div>
                </div>
            </div>

            <Breadcrumbs links={[{ label: getText({ text: 'components.siteWideJackpots.rulesTitle' }) }]} />

            <div className="swj-rules__info">
                <span className="swj-rules__info-title">
                    {getText({ text: 'components.siteWideJackpots.rulesInfoTitle' })}
                </span>
                {description && <InfoPanel description={description.map((item) => item.text)} />}
            </div>

            {!!tc_short_version && <RichText className="swj-rules__additional-info-text" content={tc_short_version} />}
            {Boolean(videoUrl) && (
                <div className="swj-rules__video-trailer">
                    <video src={videoUrl} controls onClick={handleVideoClick} onEnded={handleVideoEnded} />
                </div>
            )}

            {!!tc_full_version && (
                <div className="swj-rules__tc-long">
                    <span className="swj-rules__tc-long-title">
                        {getText({ text: 'components.siteWideJackpots.rulesLongVersionTitle' })}
                    </span>
                    <RichText className="swj-rules__tc-long-text" content={tc_full_version} />
                </div>
            )}
        </div>
    );
};

export default SWJRules;
